export default __webpack_public_path__ + "static/media/forget-ads-icon.45ecc632.svg";